import { ORDEM_ESTAGIO, ROTULO_ESTAGIO, type Estagio } from './estagio'

// O filtro da lista de Pedidos tem formas EXCLUSIVAS de recortar (pedido dela
// 17/09). `estagios` (varios de uma vez) nasceu para os atalhos da tela Inicio
// (spec 2026-09-29): "aguardando entrega" = Enviado ou Faturado.
export type FiltroLista =
  | { tipo: 'todos' }
  | { tipo: 'estagio'; estagio: Estagio }
  | { tipo: 'estagios'; estagios: Estagio[]; rotulo: string }
  | { tipo: 'periodo'; de: string; ate: string; rotulo: string }

export function filtroDoEndereco(busca: string): FiltroLista {
  const bruto = new URLSearchParams(busca).get('situacao') ?? ''
  const estagios = bruto.split(',').map((s) => s.trim()).filter((s): s is Estagio => (ORDEM_ESTAGIO as readonly string[]).includes(s))
  if (estagios.length === 0) return { tipo: 'todos' }
  if (estagios.length === 1) return { tipo: 'estagio', estagio: estagios[0] }
  return { tipo: 'estagios', estagios, rotulo: estagios.map((e) => ROTULO_ESTAGIO[e]).join(' ou ') }
}

export function linkDaSituacao(estagios: Estagio[]): string {
  return `/pedidos?situacao=${estagios.join(',')}`
}
